export const countries = [
  {
    name: "Argentina",
    code: "+54",
    flag: "AR",
    documents: [
      { label: "DNI", value: "dni", max: 8, min: 7 },
      { label: "CUIL", value: "cuil", max: 13, min: 11 },
      { label: "CUIT", value: "cuit", max: 13, min: 11 },
    ],
    currencies: [
      {
        nombre: "PESO ARGENTINO",
        simbolo: "ARS",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 10,
  },
  {
    name: "Bolivia",
    code: "+591",
    flag: "BO",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 8, min: 6 },
      { label: "PASAPORTE", value: "pas", max: 12, min: 7 },
    ],
    currencies: [
      {
        nombre: "BOLIVIANO",
        simbolo: "BOB",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 8,
  },
  {
    name: "Brasil",
    code: "+55",
    flag: "BR",
    documents: [{ label: "CPF", value: "cpf", max: 11, min: 11 }],
    currencies: [
      {
        nombre: "REAL BRASILERO",
        simbolo: "BRL",
      }
    ],
    phone: 9,
  },
  {
    name: "Chile",
    code: "+56",
    flag: "CL",
    documents: [
      { label: "RUT", value: "rut", max: 9, min: 7 },
      { label: "RUN", value: "run", max: 9, min: 7 },
      { label: "PASAPORTE", value: "pa", max: 100, min: 7 },
      { label: "CE", value: "ce", max: 100, min: 9 },
    ],
    currencies: [
      {
        nombre: "PESO CHILENO",
        simbolo: "CLP",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 9,
  },
  {
    name: "Colombia",
    code: "+57",
    flag: "CO",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 8, min: 7 },
      { label: "CC", value: "cc", max: 13, min: 10 },
      { label: "CE", value: "ce", max: 13, min: 10 },
      { label: "PAS", value: "pas", max: 18, min: 7 },
      { label: "TI", value: "ti", max: 13, min: 10 },
      { label: "NIT", value: "nit", max: 13, min: 10 },
    ],
    currencies: [
      {
        nombre: "PESO COLOMBIANO",
        simbolo: "COP",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 10,
  },
  {
    name: "Ecuador",
    code: "+593",
    flag: "EC",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 10, min: 10 },
      { label: "PASAPORTE", value: "pa", max: 18, min: 7 },
      { label: "RUC", value: "ruc", max: 13, min: 13 },
    ],
    currencies: [
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 9,
  },
  {
    name: "España",
    code: "+34",
    flag: "ES",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 10, min: 7 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
    ],
    currencies: [
      {
        nombre: "EURO",
        simbolo: "EUR",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 9,
  },
  {
    name: "Mexico",
    code: "+52",
    flag: "MX",
    documents: [
      { label: "INE", value: "ine", max: 13, min: 13 },
      { label: "CURP", value: "curp", max: 18, min: 18 },
      { label: "RFC", value: "rfc", max: 13, min: 10 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
    ],
    currencies: [
      {
        nombre: "PESOS MEXICANOS",
        simbolo: "MXN",
      },
    ],
    phone: 10,
  },
  {
    name: "Panamá",
    code: "+507",
    flag: "PA",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 10, min: 7 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
    ],
    currencies: [
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 8,
  },
  {
    name: "Perú",
    code: "+51",
    flag: "PE",
    documents: [
      { label: "DNI", value: "dni", max: 8, min: 8 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
      { label: "CARNET DE EXTRANJERIA", value: "ce", max: 12, min: 8 },
      { label: "RUC", value: "ruc", max: 11, min: 11 },
      { label: "CPP", value: "cpp", max: 9, min: 9 },
    ],
    currencies: [
      {
        nombre: "Sol Peruano",
        simbolo: "Sol",
      },
    ],
    phone: 9,
  },
  {
    name: "Rep. Dominicana",
    code: "+1",
    flag: "DO",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 10, min: 7 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
    ],
    currencies: [
      {
        nombre: "PESOS DOMINICANOS",
        simbolo: "DOP",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 10,
  },
  {
    name: "Venezuela",
    code: "+58",
    flag: "VE",
    documents: [
      { label: "CEDULA DE IDENTIDAD", value: "ci", max: 9, min: 7 },
      { label: "PASAPORTE", value: "pas", max: 18, min: 7 },
    ],
    currencies: [
      {
        nombre: "Bolivar",
        simbolo: "Bs.S",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    area: ["412", "414", "424", "416", "426"],
    phone: 7,
  },
  {
    name: "Guatemala",
    code: "+502",
    flag: "GT",
    documents: [
      { label: "DOCUMENTO DE IDENTIDAD (DPI)", value: "ci", max: 15, min: 10 },
      { label: "PASAPORTE", value: "pas", max: 15, min: 0 },
    ],
    currencies: [
      {
        nombre: "Quetzal",
        simbolo: "GTQ",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 8,
  },
  {
    name: "Paraguay",
    code: "+595",
    flag: "PY",
    documents: [
      { label: "DOCUMENTO DE IDENTIDAD", value: "ci", max: 9, min: 6 },
      { label: "PASAPORTE", value: "pas", max: 15, min: 0 },
    ],
    currencies: [
      {
        nombre: "Guaraní Paraguayo",
        simbolo: "PYG",
      },
      {
        nombre: "Dólar",
        simbolo: "$",
      },
    ],
    phone: 10,
  },
];
